<template>
  <div class="content">
    <div class="main">

        <div class="container text-center">
          <h2>{{ title }}</h2>
        </div>

        <div class="container">
          <table>
            <tr><td><a href="https://pages.mtu.edu/~suits/Physicsofmusic.html" target="_blank">B. H. Suits' Physics of Music course notes.</a></td></tr>
            <tr><td><a href="https://www.torvund.net/guitar/index.php?page=progressions" target="_blank">Progressions on www.torvund.net</a></td></tr>
            <tr><td><a href="http://www.icce.rug.nl/~soundscapes/DATABASES/AWP/awp-notes_on.shtml" target="_blank">Alan W. Pollack's Notes On .. Series, a musical analsysi of all 187 Beatles songs.</a></td></tr>
            <tr><td><a href="https://www.amazon.com/Melody-Harmony-Guitarists-John-Duarte/dp/0786676884">John Duarte's Melody &amp; Harmony for Guitarists</a></td></tr>
          </table>
        </div>

    </div>
  </div>
</template>

<script>
import * as MusicData from '@/data/music_data'

export default {
  name: "References",
  components: {
  },
  data() {
    return {
      title: "References",
      rootKeys: MusicData.notes,
      chords: {
        rootKey: 'C'
      }
    };
  },
  mounted: function () {
  },
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1,
.h1 {
  font-family: "kingthings_organicaextra_bold", Impact, "Arial Black",
    sans-serif;
}
</style>
